module.exports = __webpack_public_path__ + "static/media/products.28d7b7dd.svg";